import { environment } from 'src/environments/environment';
import { RedirectAccount, SelfServiceableProducts } from '../../redirect/models/self-serviceable-accounts.model';
import {
  AccountDirectLinkDestination,
  CardAccount,
  LoanAccount,
  SelfServiceableAccounts,
} from '../models/accounts.model';
import { ProfilePaperless, ProfilePaperlessNormalized } from '../../profile/models/profile-paperless.model';

export const getTotalAccountCount = (accounts: SelfServiceableAccounts): number => {
  if (!accounts) {
    return 0;
  }
  return (
    accounts?.bechAccounts.length +
    accounts?.cardAccounts.length +
    (accounts?.loanAccounts?.[0]?.accountDetailsList.length || 0)
  );
};

export const getRedirectAccountArray = (accounts: SelfServiceableAccounts): RedirectAccount[] => {
  const redirectList: RedirectAccount[] = [];

  if (accounts?.loanAccounts) {
    accounts.loanAccounts.forEach((loanAccount) => {
      if (loanAccount?.url) {
        redirectList.push({ type: SelfServiceableProducts.LOAN, title: 'personal loan account', url: loanAccount.url });
      }
    });
  }

  if (accounts?.cardAccounts) {
    accounts.cardAccounts.forEach((cardAccount) => {
      if (cardAccount?.lastFourCardNumber) {
        redirectList.push({
          type: SelfServiceableProducts.CARD,
          title: 'credit card account',
          url: `${environment.authUrl}/saml2`,
          saml: cardAccount.saml,
          lastFourCardNumber: cardAccount.lastFourCardNumber,
          secondLevelValidated: cardAccount.secondLevelValidated,
        });
      }
    });
  }

  if (accounts?.bechAccounts) {
    accounts.bechAccounts.forEach((bechAccount) => {
      redirectList.push({
        type: SelfServiceableProducts.BECH,
        title: 'financial health',
        url: bechAccount.url,
      });
    });
  }

  return redirectList;
};

export const getAccountDirectLink = (
  url: string,
  destination: AccountDirectLinkDestination,
  accountId: number
): string => {
  const matchExp = /\/token\?domain=\d+$/gm;
  if (!url.match(matchExp)) {
    return url;
  }
  return `${url}&destination=${destination}&id=${accountId}`;
};

export const getIsValidDirectLink = (url: string) => {
  const matchExp = /\/token\?domain=\d+(&destination=\w+)(&id=\d+)$/g;
  return url.match(matchExp);
};

export const getPastDueLoanAccount = (accounts: LoanAccount[]) => {
  return accounts ? accounts.find((account) => account.accountStatus.toLowerCase() === 'past due') : null;
};

export const getHasPastDueCardAccount = (accounts: CardAccount[]) => {
  return accounts.some((account) => account.accountStatus?.toLowerCase() === 'past due');
};

export const getLoanAccountPaperlessData = (
  loanAccount: LoanAccount,
  paperlessProfiles: ProfilePaperlessNormalized
): ProfilePaperless => {
  const matchedPaperlessProfile = paperlessProfiles?.[loanAccount.fullExternalAccountNumber];
  return matchedPaperlessProfile
    ? {
        repossessionCaseStatus: matchedPaperlessProfile.repossessionCaseStatus,
        reinstatedDate: matchedPaperlessProfile.reinstatedDate,
        paperlessEnrollmentStatus: matchedPaperlessProfile.paperlessEnrollmentStatus,
        accountStatus: matchedPaperlessProfile.accountStatus,
        fullExternalAccountNumber: matchedPaperlessProfile.fullExternalAccountNumber,
      }
    : {
        repossessionCaseStatus: '',
        reinstatedDate: '',
        paperlessEnrollmentStatus: null,
        accountStatus: null,
        fullExternalAccountNumber: null,
      };
};
